import React, { useEffect } from 'react';
import Store from './Store';
import { Helmet } from "react-helmet";
import StoryContainer from './container/StoryContainer';
import './App.scss';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import ReactGA from "react-ga4";
import { getEnvironment, getCookieyesId } from './utils/helpers';

let country = window.location.href.indexOf("usa") != -1 ? 'us' : 'uk';

if (country === 'us'){
  ReactGA.initialize("G-VCC3CN6RTR");
}else{
  ReactGA.initialize("G-5V73WL5TWH");
}
// ReactGA.initialize("G-9R3S0492XE");

const environment = getEnvironment();
let cookieyesId = getCookieyesId(environment);
let clarityId = country === 'uk' ? 'ub4b8jbk63' : 'ub4bvsl1o3';

function App() {
  
  useEffect(() => {
    // Load Clarity script dynamically
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${clarityId}`;
    
    const clarityInit = document.createElement('script');
    clarityInit.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${clarityId}");
    `;
    
    document.head.appendChild(clarityInit);
  }, []);

  return (
    <Store className="App">
      <Helmet>
        <meta name="robots" content="noindex"></meta>
         {cookieyesId && country === 'uk' && (
          <script id="cookieyes" type="text/javascript" src={`https://cdn-cookieyes.com/client_data/${cookieyesId}/script.js`}></script>
        )}

        <script type="text/javascript" src="//script.crazyegg.com/pages/scripts/0130/4183.js" async="async" ></script>
      </Helmet>
      <Router>
        <Switch>
          <Route path="/:guid">
            <StoryContainer ></StoryContainer>
          </Route>
        </Switch>
      </Router>
    </Store>
  );
}

export default App;
